import { render, staticRenderFns } from "./CardChartOpinionSurvey.vue?vue&type=template&id=8dcff1b4&scoped=true&"
import script from "./CardChartOpinionSurvey.vue?vue&type=script&lang=js&"
export * from "./CardChartOpinionSurvey.vue?vue&type=script&lang=js&"
import style0 from "./CardChartOpinionSurvey.vue?vue&type=style&index=0&id=8dcff1b4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcff1b4",
  null
  
)

export default component.exports